import axios from "~src/utils/axios";
import type { IItemString } from "~src/interfaces/commom";

const BASE_URL: IItemString = {
  // football: "http://localhost:3004",
  football: "https://fs.api-football.xyz",
};

const getApiUrl = (sportType: string, path: string) => {
  return `${BASE_URL[sportType]}/${path}`;
};

export const getMatchDetail = async (matchID = "", sportType = "football") => {
  const url = getApiUrl(sportType, `matches/match-detail/${matchID}`);

  return await axios.get(url);
};

export const getAllTeams = async (sportType = "football") => {
  const url = getApiUrl(sportType, `team/get-all`);

  return await axios.get(url);
};

export const findTeam = async (teamID = "", sportType = "football") => {
  const url = getApiUrl(sportType, `team/find/${teamID}`);

  return await axios.get(url);
};

export const getPlayerLists = async (
  playerIds: number[] = [],
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `players/finds`);

  return await axios.post(url, {
    playerIds,
  });
};

export const getTeamLists = async (
  teamIds: number[] = [],
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `team/finds`);

  return await axios.post(url, {
    teamIds,
  });
};

export const findTeamTheSport = async (teamID = "", sportType = "football") => {
  const url = getApiUrl(sportType, `team/find-the-sport/${teamID}`);

  return await axios.get(url);
};
